<template>
  <div class="zoom-control pa-0 ma-0">
    <div class="zoom-button">
      <v-btn
        small
        fab
        height="30"
        dark
        color="rgba(19, 55, 102, 0.72)"
        @click="zoomIn"
      >
        <v-icon small>mdi-plus</v-icon>
      </v-btn>
    </div>
    <v-btn small fab height="22">
      {{ zoom }}
    </v-btn>
    <div class="zoom-button">
      <v-btn
        small
        fab
        height="30"
        dark
        color="rgba(19, 55, 102, 0.72)"
        @click="zoomOut"
      >
        <v-icon small>mdi-minus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZoomControl",
  props: {
    map: {
      type: Object,
      default: null
    }
  },
  computed: {
    zoom() {
      if (!this.map) return 0;
      return Math.floor(this.map.getZoom());
    }
  },
  methods: {
    zoomIn() {
      this.map.setZoom(this.map.getZoom() + 1);
    },
    zoomOut() {
      this.map.setZoom(this.map.getZoom() - 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.zoom-control {
  pointer-events: painted;
  width: 32px;
  .v-btn {
    border-radius: 0;
  }
  .zoom-button {
    width: 100%;
  }
  .zoom {
    text-align: center;
    background-color: white;
    font-weight: bold;
  }
  .v-btn--fab.v-size--small {
    width: 100%;
    padding: auto;
  }
}
</style>
